<script setup lang="ts">
import { useGlobalStore } from "~/stores/globalStore";
const globalStore = useGlobalStore();
const { isMobile } = useDevice();

const points = [
  "Tell your requirements",
  "Choose developers",
  "Onboard remote programmers",
  "Manage extended team",
  "Get your project delivered",
];
</script>

<template>
  <div class="relative">
    <div
      v-for="(point, index) in points"
      :key="index"
      :class="[
        'relative max-w-[395px] lg:max-w-[470px] mx-auto first:mt-0 max-md:mb-16 md:-mt-[56px]',
      ]"
      :style="{ zIndex: 5 - index }"
    >
      <span
        :class="[
          'min-w-max absolute md:top-1/2 max-md:-bottom-10 max-md:left-1/2 -translate-y-1/2 max-md:-translate-x-1/2 text-[var(--foreground)] ',
          index % 2 === 1 ? 'md:left-[102%]' : 'md:right-[102%]',
        ]"
        >{{ "0" + (index + 1) + "." + point }}</span
      >
      <div
        :class="[
          'mx-auto relative max-md:after:content-[none] max-md:before:content-[none]',
          'after:content-[\'\'] after:w-[90px] lg:after:w-[126px] after:border-dashed after:border-t-2 after:absolute after:top-1/2 after:-translate-y-1/2 after:border-[var(--foreground)]',
          'before:content-[\'\'] before:absolute before:top-1/2 before:-translate-y-1/2',
          index % 2 === 1
            ? 'after:-right-[90px] lg:after:-right-32 before:-right-[100px] lg:before:-right-[138px] triangle-right'
            : 'after:-left-[90px] lg:after:-left-32 before:-left-[100px] lg:before:-left-[138px] triangle-left',
        ]"
        class="w-[195px] h-[123px]"
      >
        <NuxtImg
          src="/images/step.webp"
          alt="processStep Image"
          :width="isMobile ? 195 : 195"
          :height="isMobile ? 123 : 123"
          loading="lazy"
          format="webp"
        />
      </div>
      <span
        :class="[
          'text-[#F680F2] text-4xl absolute top-1/2 left-1/2 -translate-x-1/2',
          index === 0
            ? '-translate-y-[60%]'
            : '-translate-y-[60%] md:-translate-y-[15%]',
        ]"
      >
        0{{ index + 1 }}.
      </span>
    </div>
    <NuxtImg
      :src="
        $colorMode.preference== 'dark'
          ? '/images/step-shadow-dark.webp'
          : '/images/step-shadow.webp'
      "
      alt="staff-augmentation-background"
      width="258"
      height="149"
      class="max-w-none mx-auto absolute top-[78%] left-1/2 -translate-x-1/2"
      loading="lazy"
      format="webp"
    />
  </div>
</template>

<style>
.triangle-left:before {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-right: 12px solid var(--foreground);
  border-bottom: 6px solid transparent;
}

.triangle-right:before {
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-left: 12px solid var(--foreground);
  border-bottom: 6px solid transparent;
}
</style>
